import React from "react";
import { productList } from "@/data/products";
import ProductCard from "@/components/ProductCard";
import SectionReveal from "@/components/SectionReveal";

export default function Products() {
  return (
    <section data-testid="products-page" className="bg-white">
      <div className="mp-container pt-10 pb-6">
        <SectionReveal>
          <div className="text-center max-w-4xl mx-auto">
            <div className="mp-eyebrow-green">Products</div>
            <h1 className="mt-3 font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.95]">
              The Combat Range
            </h1>
            <p className="mt-4 font-body text-black/70 leading-relaxed text-lg max-w-2xl mx-auto">
              A focused Indian portfolio. Two formulas engineered for athletes who train consistently — no filler, no distractions, just what works.
            </p>
          </div>
        </SectionReveal>
      </div>

      <div className="mp-container pb-16 lg:pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-10 max-w-5xl mx-auto">
          {productList.map((p, i) => (
            <SectionReveal key={p.slug} delay={i * 120}>
              <ProductCard product={p} testId={`products-card-${p.slug}`} />
            </SectionReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
